import { action, computed, observable } from "mobx";

import { PatientTab } from "@libs/gateways/clinical/ClinicalGateway.dtos.ts";
import { AutofillDto } from "@libs/gateways/document/DocumentGateway.dtos.ts";
import { UserStorageKeys } from "@libs/gateways/user-experience/UserExperienceGateway.dtos.ts";

import { UserExperienceStore } from "./UserExperienceStore.ts";
import { UserHotkeysHelper } from "./UserHotkeysHelper.ts";

export class UserExperienceUi {
  constructor(private userExperience: UserExperienceStore) {
    this.userHotkeysHelper = new UserHotkeysHelper(userExperience);
  }
  public userHotkeysHelper: UserHotkeysHelper;

  @observable public showHelpDialog = false;

  @action public toggleHelpDialogVisibility = (visible?: boolean) => {
    this.showHelpDialog = visible || !this.showHelpDialog;
  };

  @observable
  editingAutoFill: AutofillDto | undefined;

  @action public setEditingAutoFill = (autofill: AutofillDto | undefined) => {
    this.editingAutoFill = autofill;
  };

  openTab = async (newTab: PatientTab, ignoreCache: boolean = false) => {
    const existingTabs = await this.getTabs(ignoreCache ?? false);
    const updatedTabs = [newTab, ...existingTabs];

    this.saveTabs(updatedTabs);
  };

  closeTab = async (
    filter: (tab: PatientTab) => boolean,
    ignoreCache: boolean = false
  ) => {
    const existingTabs = await this.getTabs(ignoreCache);
    const updatedTabs = existingTabs.filter(filter);

    this.saveTabs(updatedTabs);
  };

  private getTabs = async (ignoreCache: boolean) => {
    const tabs = await this.userExperience.getUserStorage(
      UserStorageKeys.OpenPatientTabs,
      {
        ignoreCache
      }
    );
    return tabs ?? [];
  };

  private saveTabs = (patientTabs: PatientTab[]) => {
    this.userExperience.saveToUserStorage(
      UserStorageKeys.OpenPatientTabs,
      patientTabs
    );
  };

  @computed get apptTypeBaseInterval() {
    return (
      this.userExperience.orgUnitSettingForLocation?.dto.appointmentSetting
        ?.apptTypeBaseInterval || "15"
    );
  }
}
